import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useSearchStore } from "~/stores/searchStore";

const DEBOUNCE_MS = 300;

export default () => {
  const location = useLocation();
  const searchOptions = useSearchStore();
  const setSearchOptions = useSearchStore((s) => s.setSearchOptions);
  const debounceRef = useRef(null);

  const setSearch = (value) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setSearchOptions({ value });
    }, DEBOUNCE_MS);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const updateSearchTerm = (value) => {
    setSearch(value);
  };

  useEffect(() => {
    if (location.pathname !== searchOptions.scope) {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      setSearchOptions({
        value: "",
        scope: location.pathname,
      });
    }
  }, [location.pathname, searchOptions.scope]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  return {
    handleSearch,
    updateSearchTerm,
    searchValue: searchOptions?.value,
  };
};
